import React, { useMemo } from 'react';

import type { IngestionJobStatus } from '../../../../../../apis/graphql';
import { CreativeV5Type } from '../../../../../../apis/graphql';
import Tooltip from '../../../../../Tooltip';
import { ingestButton } from '../../../configs';
import { IngestPill } from '../../IngestPill';
import MultiCountryAssetIngestButton from '../../MultiCountryAssetIngestButton';

export type AssetIngestStatusActionsProps = {
  ingestStatus?: IngestionJobStatus;
  hasIngestError?: boolean;
  creativeType: CreativeV5Type;
};

const AssetIngestStatusActions = ({
  ingestStatus,
  hasIngestError,
  creativeType,
}: AssetIngestStatusActionsProps): React.JSX.Element => {
  const { tooltipConfig, tooltipText } = ingestButton;

  const isDraxCreative = useMemo(() => creativeType === CreativeV5Type.Drax, [creativeType]);

  return (
    <>
      {ingestStatus && <IngestPill ingestStatus={ingestStatus} />}
      {!isDraxCreative && (
        <Tooltip id="vast-footer-tooltip" className="tooltip" message={tooltipText} {...tooltipConfig}>
          <MultiCountryAssetIngestButton displayRetry={hasIngestError} />
        </Tooltip>
      )}
    </>
  );
};

export default AssetIngestStatusActions;
